import React, { FC } from 'react';
import { Alert as AntdAlert, AlertProps as AntdAlertProps, ConfigProvider } from 'antd';
import { BsFillInfoSquareFill } from 'react-icons/bs';

interface AlertProps extends AntdAlertProps {
    variant?: 'info' | 'error' | 'success' | 'warning';
    title?: string;
}

export const Alert: FC<AlertProps> = (props) => {
    const renderIcon = (variant: typeof props.variant) => {
        switch (variant) {
            case 'info':
                return <BsFillInfoSquareFill />;
            case 'error':
                return <BsFillInfoSquareFill />;
            case 'success':
                return <BsFillInfoSquareFill />;
            case 'warning':
                return <BsFillInfoSquareFill />;
            default:
                return props?.icon ?? <></>;
        }
    };

    const renderStyles = (variant: typeof props.variant) => {
        switch (variant) {
            case 'info':
                return 'bg-primary-20 border border-primary-40 bg-opacity-20 ';
            case 'error':
                return '';
            case 'success':
                return 'bg-positive-default bg-opacity-10 border border-positive-dark';
            case 'warning':
                return 'bg-warning-default bg-opacity-10 border border-warning-default ';
            default:
                return '';
        }
    };

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontSizeSM: 12,
                    fontSizeLG: 14,
                },
                components: {
                    Alert: {
                        withDescriptionIconSize: 20,
                    },
                },
            }}
        >
            <AntdAlert
                {...props}
                showIcon
                icon={renderIcon(props.variant)}
                type={props.variant}
                description={props.message}
                message={props.title ?? <></>}
                className={'p-3 rounded-lg ' + renderStyles(props.variant) + props.className}
            />
        </ConfigProvider>
    );
};
